import React, { useRef } from 'react';
import { Script } from 'gatsby';
import PropTypes from 'prop-types';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
// import { useVideoContext } from '../../../context/videoContext';
import { testAttributes, defaultAttributes } from './Constants';
import { videoAreaContainer } from './VideoArea.module.scss';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

const VideoArea = ({ videoId, snippet = {}, classNames = '' }) => 
{
    const myRef = useRef(null);
    // TODO: fix the video provider, is failing due to the window object not being available in SSR
    // const { onIframeAdded } = useVideoContext();

    return (
        <div
            id={`video-container-${videoId}`}
            data-testid={testAttributes.VIDEO_AREA_CONTAINER}
            className={videoAreaContainer}
        >
            <Script
                src="https://www.youtube.com/iframe_api"
                data-testid={testAttributes.VIDEO_AREA_SCRIPT} 
            />
            <LiteYouTubeEmbed
                id={videoId}
                title={snippet?.title}
                iframe
                // onIframeAdded={() => onIframeAdded(videoId)}
                cookie
                params={`${defaultAttributes.VIDEO_AUTO_PLAY}&${defaultAttributes.VIDEO_AREA_PARAMS}`}
                wrapperClass={classNames}
                iframeClass={defaultAttributes.VIDEO_AREA_IFRAME}
                allow={defaultAttributes.VIDEO_AUTO_ALLOW_ATTRIBUTES}
                ref={myRef}
                poster={defaultAttributes.VIDEO_THUMBNAIL_QUALITY}  
            />
        </div>
    );
};

VideoArea.propTypes = {
    videoId: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    snippet: PropTypes.shape({
        title: PropTypes.string,
    }),
    classNames: PropTypes.string,
};

export default VideoArea;